import { render, staticRenderFns } from "./debounce-button.vue?vue&type=template&id=589b93b2&scoped=true"
import script from "./debounce-button.vue?vue&type=script&lang=js"
export * from "./debounce-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b93b2",
  null
  
)

export default component.exports